import React from 'react'
import { Switch, Route, Redirect, Link } from 'react-router-dom'

import Login from './Login'

import * as AuthService from 'services/auth.service'

import '_metronic/_assets/sass/pages/login/login-1.scss'

import ForgotPassword from './ForgotPassword'

export default function AuthPage() {

  const [imageBase64, setImageBase64] = React.useState(null)

  React.useEffect(() => {
    AuthService.obtenerCompaniaLogo()
      .then(({ data }) => {
        setImageBase64(data || '')
      })
      .catch(({ data: { error } }) => console.log(error))
  }, [])

  const isForgotPasswordPage = window.location.pathname === '/auth/forgot-password';

  return (
    <>
      <div id='login_main-container'>
        <div className='zr-sheet login-sheet'>
          <div className='login-title-container'>
            {imageBase64 !== null && imageBase64 !== '' && (
              <div style={{ width: '100%', textAlign: 'center', justifyContent: "center", marginBottom: "40px" }}>
                <img src={imageBase64} alt="Base64" style={{ maxWidth: '150px', maxHeight: '150px' }} />
              </div>
            )}
            <h1 className='login-title'>CONTASOFT</h1>
            <h3 className='login-subtitle'>C·O·N·T·A·B·I·L·I·D·A·D</h3>
          </div>
          <Switch>
            <Route path='/auth/login' component={Login} />
            <Route path='/auth/forgot-password' component={ForgotPassword} />
            <Redirect from='/auth' exact={true} to='/auth/login' />
            <Redirect to='/auth/login' />
          </Switch>
          {!isForgotPasswordPage && ( // Renderiza el Link solo si la ruta no es '/auth/forgot-password'
            <Link to='/auth/forgot-password' className='login-recuperar-contrasena'>
              Recuperar contraseña
            </Link>
          )}
        </div>
      </div>
    </>
  )
}
